(function () {

  angular.module('CopilotProvider', [])

    .constant('CopilotConstants', {
      genaiProvidersLink: 'px:genaiProviders',
      emptyRequestedAction: {
        userRequest: '',
        responseType: '',     // Should be a value from the GenAIResponseTypes id
        printerSearchString: '',
        userParameters: { email: '', role: '' },
        newNetworkName: '',
        authenticationSection: '',
        siteName: '',
        workflowName: '',
        discoverOnNetworkName: '',
        cloudStorageParameters: { name: '', provider: '' },
        supportTicket: {
          subject: '',
          description: '',
          ticketProduct: 'PRINTIX',
          ticketPriority: 'NORMAL'
        },
        helpResults: {
          queryString: '',
          totalSearchResultsCount: 0,
          searchResults: [],
          displayResults: false
        },
        errorMessage: ''
      }
    })

    .service('CopilotService', function (
      $http, $location, $q, $rootScope, $route, $timeout, $window, URLS, CopilotConstants, URL_PARAMS, TenantListService, Utils
    ) {
      const self = this;

      self.state = {
        initialized: false,         // Copilot data is initialized from the server
        enabled: false,             // Copilot is enabled. False until we get the configuration from the server.
        isGlobalProviderAvailable: undefined, // Global provider is available. Undefined until we get the configuration from the server.
        chatOpen: false,            // Copilot window is open
        copilotWidth: 0,            // Width of the Copilot window
        isConfigurationOpen: false, // Copilot configuration window is open
        configured: false,          // GenAI provider is configured
        isFormDirty: false,
        requestedAction: { ...CopilotConstants.emptyRequestedAction }
      };

      // Copilot window is open
      self.setChatOpen = function (isOpen) {
        // Delay the setting of the chatOpen state.
        // Without this delay, if there is another modal dialog open,
        // then the click to close the chat window will also close the modal dialog.
        $timeout(function () {
          self.state.chatOpen = isOpen;
        });
      };

      // Generative AI configuration window is open
      self.setConfigurationOpen = function (isOpen) {
        self.state.isConfigurationOpen = isOpen;
      };

      // Indicates that there is a form that has been modified and that
      // Copilot should not navigate away from the current page.
      self.setFormDirty = function (isFormDirty) {
        self.state.isFormDirty = isFormDirty;
      };

      self.getAvailableWidth = function () {
        return $window.innerWidth - self.state.copilotWidth;
      };

      self.navigate = function (requestedAction) {
        const responseType = requestedAction.responseType;
        const redirectValues = (function () {
          switch (responseType) {
            case 'SUBSCRIPTION':
              return { url: URLS.SUBSCRIPTION };
            case 'IMPLEMENTATION_ASSISTANT':
              return { url: URLS.DEPLOY_ASSISTANT };
            case 'SIGN_IN_METHOD':
              return {
                url: URLS.AUTHENTICATION_SETTINGS,
                search:
                    requestedAction.authenticationSection
                      ? { authenticationSection: requestedAction.authenticationSection }
                      : undefined
              };
            case 'ADD_USER':
              return { url: URLS.ADD_USER };
            case 'NETWORKS':
              return { url: URLS.NETWORK_LIST };
            case 'SITES':
              return { url: URLS.SITES.replace(URL_PARAMS.SITES_IDS.LOCATION, '') };
            case 'DISCOVER_PRINTERS':
              return { url: URLS.PRINTER_LIST };
            case 'SEARCH_PRINTERS':
              return { url: URLS.PRINTER_LIST };
            case 'WORKFLOWS':
              return { url: URLS.SETTINGS, search: { [URL_PARAMS.SHOW_SETTINGS_SECTION.ROUTE]: 'workflows' } };
            case 'ANALYTICS':
              return { url: URLS.SETTINGS, search: { [URL_PARAMS.SHOW_SETTINGS_SECTION.ROUTE]: 'analytics' } };
            case 'CLOUD_STORAGE':
              return { url: URLS.SETTINGS, search: { [URL_PARAMS.SHOW_SETTINGS_SECTION.ROUTE]: 'cloudStorage' } };
            case 'TECHNICAL_SUPPORT':
              return { url: URLS.SUPPORT };
            case 'HELP':
              return { url: 'https://docshield.tungstenautomation.com/Printix/en_US/help/admin/Printix_admin/c_how_to.html' };
          }
        })();

        if (redirectValues === undefined) {
          return;
        }

        if (redirectValues.url.startsWith('https://docshield.tungstenautomation.com/')) {
          let url = redirectValues.url;
          if (self.state.requestedAction.helpResults.queryString) {
            url += `?s=${self.state.requestedAction.helpResults.queryString}`;
          }
          $window.open(url, '_blank');
        } else if (redirectValues.search) {
          if ($location.path() === redirectValues.url && JSON.stringify($location.search()) === JSON.stringify(redirectValues.search)) {
            $route.reload();
          } else {
            $location.path(redirectValues.url).search(redirectValues.search);
          }
        } else {
          if ($location.path() === redirectValues.url) {
            $route.reload();
          } else {
            $location.path(redirectValues.url);
          }
        }
      };

      self.usePrinterSearchString = function () {
        const printerSearchString = self.state.requestedAction.printerSearchString;
        if (self.state.requestedAction.responseType === 'SEARCH_PRINTERS') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return printerSearchString;
      };

      self.useUserParameters = function () {
        const userParameters = self.state.requestedAction.userParameters;
        if (self.state.requestedAction.responseType === 'ADD_USER') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return userParameters;
      };

      self.useSiteName = function () {
        const siteName = self.state.requestedAction.siteName;
        if (self.state.requestedAction.responseType === 'SITES') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return siteName;
      };

      self.useWorkflowName = function () {
        const workflowName = self.state.requestedAction.workflowName;
        if (self.state.requestedAction.responseType === 'WORKFLOWS') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return workflowName;
      };

      self.useNetworkName = function () {
        const newNetworkName = self.state.requestedAction.newNetworkName;
        if (self.state.requestedAction.responseType === 'NETWORKS') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return newNetworkName;
      };

      self.useDiscoverOnNetworkName = function () {
        const discoverOnNetworkName = self.state.requestedAction.discoverOnNetworkName;
        if (self.state.requestedAction.responseType === 'DISCOVER_PRINTERS') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        } return discoverOnNetworkName;
      };

      self.useCloudStorageParameters = function () {
        const cloudStorageParameters = self.state.requestedAction.cloudStorageParameters;
        if (self.state.requestedAction.responseType === 'CLOUD_STORAGE') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return cloudStorageParameters;
      };

      self.useSupportParameters = function () {
        const supportParameters = self.state.requestedAction.supportTicket;
        if (self.state.requestedAction.responseType === 'TECHNICAL_SUPPORT') {
          self.state.requestedAction = { ...CopilotConstants.emptyRequestedAction };
        }
        return supportParameters;
      };

      self.searchHelp = function (searchText) {
        const searchResults = doSearchHelp('en', searchText);
        const totalSearchResultsCount = searchResults.exactPhraseResults.length + searchResults.fuzzyResults.length;

        // Full results are first 2 exact phrase results (if they exist) followed by fuzzy results for a total of no more than 3 results
        const topResults = searchResults.exactPhraseResults.slice(0, 2)
          .concat(searchResults.fuzzyResults.slice(0, 3 - searchResults.exactPhraseResults.length));

        const helpResults = {
          queryString: encodeURIComponent(searchText),
          totalSearchResultsCount,
          searchResults: topResults.map(result => {
            return {
              href: result.h,
              title: result.t,
              summary: result.s
            };
          }),
          displayResults: true
        };
        return helpResults;
      };

      // Make the chat request
      self.requestGenerativeAiResponse = function (message) {
        const deferred = $q.defer();

        const url = TenantListService.currentTenant.info._links['px:genaiProviders'].href.replace('/providers', '');
        const body = { userMessage: message };

        $http.post(url, body)
          .then(function (response) {
            try {
              deferred.resolve(transformChatResponse(response));
            } catch (error) {
              deferred.reject(error);
            }
          })
          .catch(function (error) {
            deferred.reject(error);
          });

        return deferred.promise;
      };

      // Transform the response into a requested action
      function transformChatResponse(response) {
        const requestedAction = { ...CopilotConstants.emptyRequestedAction };
        const adminChatAction = response.data.adminChatAction;
        requestedAction.responseType = adminChatAction;

        switch (adminChatAction) {
          case 'SIGN_IN_METHOD':
            const section = response.data.adminChatActionParameters?.type || 'GENERAL';
            switch (section) {
              case 'GENERAL':
                requestedAction.authenticationSection = 'setup';
                break;
              case 'AZURE':
                requestedAction.authenticationSection = 'azure';
                break;
              case 'GOOGLE':
                requestedAction.authenticationSection = 'google';
                break;
              case 'OIDC':
                requestedAction.authenticationSection = 'oidc';
                break;
              case 'ONE_LOGIN':
                requestedAction.authenticationSection = 'onelogin';
                break;
              case 'OKTA':
                requestedAction.authenticationSection = 'okta';
                break;
              case 'AD':
                requestedAction.authenticationSection = 'ad';
                break;
              case 'SELF_REGISTER':
                requestedAction.authenticationSection = 'selfRegister';
                break;
            }
            break;
          case 'ADD_USER':
            if (response.data.adminChatActionParameters) {
              requestedAction.userParameters = response.data.adminChatActionParameters;
            }
            break;
          case 'NETWORKS':
            requestedAction.newNetworkName = response.data.adminChatActionParameters?.name || '';
            break;
          case 'SITES':
            requestedAction.siteName = response.data.adminChatActionParameters?.name || '';
            break;
          case 'DISCOVER_PRINTERS':
            requestedAction.discoverOnNetworkName = response.data.adminChatActionParameters?.name || '';
            break;
          case 'SEARCH_PRINTERS':
            requestedAction.printerSearchString = response.data.adminChatActionParameters?.name || '';
            break;
          case 'WORKFLOWS':
            requestedAction.workflowName = response.data.adminChatActionParameters?.name || '';
            break;
          case 'CLOUD_STORAGE':
            if (response.data.adminChatActionParameters) {
              requestedAction.cloudStorageParameters = response.data.adminChatActionParameters;
            }
            break;
          case 'TECHNICAL_SUPPORT':
            if (response.data.adminChatActionParameters) {
              requestedAction.supportTicket = response.data.adminChatActionParameters;
            }
            break;
          case 'HELP':
            const stringParam = response.data.adminChatActionParameters?.name || '';
            requestedAction.helpResults = self.searchHelp(stringParam);
            break;
          case 'UNKNOWN':
            requestedAction.errorMessage = response.data.adminChatActionParameters?.errorMessage || '';
            break;
          // No parameters needed for these actions
          case 'ANALYTICS':
          case 'SUBSCRIPTION':
          case 'IMPLEMENTATION_ASSISTANT':
            break;
        }

        self.state.requestedAction = requestedAction;
        return requestedAction;
      }

      self.getConfiguration = function () {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links[CopilotConstants.genaiProvidersLink].href;
        $http.get(url)
          .then(function (response) {
            const providerList = response.data._embedded?.[CopilotConstants.genaiProvidersLink] ?? [];
            self.currentConfiguration = providerList[0];
            self.updateState();
            deferred.resolve(self.currentConfiguration ? { ...self.currentConfiguration } : undefined);
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      self.getGlobalProviderEnabled = function () {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links[CopilotConstants.genaiProvidersLink].href + '/global';
        $http.get(url)
          .then(function (response) {
            const isGlobalProviderAvailable = response.data === 'true';
            self.state.isGlobalProviderAvailable = isGlobalProviderAvailable;
            deferred.resolve(isGlobalProviderAvailable);
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      self.saveConfiguration = function (newConfiguration) {
        // Determine if we are creating or updating.
        const isCreating = self.currentConfiguration === undefined;
        return isCreating ? self.createNewConfiguration(newConfiguration) : self.updateConfiguration(newConfiguration);
      };

      self.createNewConfiguration = function (newConfiguration) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links[CopilotConstants.genaiProvidersLink].href;
        $http.post(url, newConfiguration)
          .then(function (response) {
            self.currentConfiguration = response.data;
            self.updateState();
            deferred.resolve({ ...self.currentConfiguration });
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      self.updateConfiguration = function (newConfiguration) {
        const deferred = $q.defer();

        const makeCopy = function (obj) {
          return { type: obj.type, enabled: obj.enabled, model: obj.model, apiUrl: obj.apiUrl, apiKey: obj.apiKey };
        };

        // Determine if we are creating or updating.
        const currentCopy = makeCopy(self.currentConfiguration);
        const newCopy = makeCopy(newConfiguration);
        const patchObjectArray = Utils.getObjectsDifferencesForPatching(currentCopy, newCopy);
        if (patchObjectArray !== undefined && patchObjectArray.length <= 0) {
          deferred.resolve('No changes to save');
          return deferred.promise;
        }

        const url = self.currentConfiguration._links.self.href;
        $http.patch(url, patchObjectArray)
          .then(function (response) {
            self.currentConfiguration = response.data;
            self.updateState();
            deferred.resolve({ ...self.currentConfiguration });
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

      self.updateState = function () {
        self.state.initialized = true;
        if (self.currentConfiguration === undefined) {
          // If no configuration exists, then enable the chat window so the user can use it to get to the configuration.
          self.state.enabled = true;
          return;
        }
        self.state.enabled = self.currentConfiguration.enabled;
        self.state.configured = self.state.enabled && self.currentConfiguration.apiUrl?.length > 0;
      };

      // Initialize the configuration once we have the current tenant
      $rootScope.$watch(function () {
        return TenantListService.currentTenant;
      }, function () {
        if (TenantListService.currentTenant && self.state.initialized === false) {
          self.getConfiguration();
          self.getGlobalProviderEnabled();
        }
      });

    });

})();
